<template>
  <div class="boxbottom">
    <div
      style="width: 1280px; background-color: #FFFFFF;border: 1px solid #ebe9e9;border-bottom: 0px; height: 40px;margin: 0 auto;flex: row; display: flex; justify-content: flex-end;">
      <div style="width: 600px;display: flex;justify-content: space-around;align-items: center;">
        <div class="a">
          <div class="dian cyc"></div>冲一冲：<span style="color: #F53824;">{{cyc}}</span>
        </div>
        <div class="a">
          <div class="dian wyw"></div>稳一稳：<span style="color: #fe9b0e;">{{wyw}}</span>
        </div>
        <div class="a">
          <div class="dian byb"></div>保一保：<span style="color: #0081cc;">{{byb}}</span>
        </div>
        <div class="a">
          <div class="dian dyd"></div>垫一垫：<span style="color: #00B54F;">{{dyd}}</span>
        </div>
      </div>
      <div @click="openyixuan"
        style="width: 200px;height: 100%;background-color: #f66464;color: #FFFFFF; font-size: 16px;font-weight: bold;display: flex; align-items: center;justify-content: center;">
        生成志愿<span style="margin-left: 15px;" v-if="all != 0">  ( {{all}} )</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        cyc: 0,
        wyw: 0,
        byb: 0,
        dyd: 0,
        tianbaoType: this.$utils.getlocalStorage('tianbaoType'),
        all:0
      };
    },
    computed: {},
    methods: {
      changedataAll() {
        console.log(111)
        let _this = this;
        this.$nextTick(()=>{
         if (_this.tianbaoType != 0) {
           _this.cyc = _this.$utils.getlocalStorage("ZhiYuancyc").ids.length
           _this.wyw = _this.$utils.getlocalStorage("ZhiYuanwyw").ids.length
           _this.byb = _this.$utils.getlocalStorage("ZhiYuanbyb").ids.length
           _this.dyd = _this.$utils.getlocalStorage("ZhiYuandyd").ids.length
           _this.all =_this.cyc+_this.wyw+_this.byb+_this.dyd
         } else {
           let map = _this.$utils.getlocalStorage("ZhiYuancyc").map
           _this.cyc = 0;
           _this.wyw = 0;
           _this.byb = 0;
           _this.dyd = 0;
           for(let o in map){
             if (map[o].rate <= _this.$rate.cyc) {
               _this.cyc++;
             } else if (map[o].rate > _this.$rate.cyc && map[o].rate <= _this.$rate.wyw) {
               _this.wyw++;
             } else if (map[o].rate > _this.$rate.wyw && map[o].rate <= _this.$rate.byb) {
               _this.byb++;
             } else if (map[o].rate > _this.$rate.byb) {
               _this.dyd++;
             }
           }
           _this.all =Object.keys(map).length
           _this.$utils.setlocalStorage("ZhiYuanYixuan",_this.all)
         }
        })
      },
      openyixuan(){
        this.$emit("openyixuan",{flag: true});
      }
    },
    created() {
      this.changedataAll()
    }
  };
</script>

<style scoped>
  .boxbottom {
    position: fixed;
    bottom: 0;
    width: 100%;
  }

  .a {
    width: 200px;
    display: flex;
    justify-content: center;
  }
  .cyc{
    background-color: #F53824;
  }
  .wyw{
    background-color: #fe9b0e;
  }
  .byb{
    background-color: #0081cc;
  }
  .dyd{
    background-color: #00B54F;
  }

  .dian {
    width: 20px;
    height: 20px;
    border-radius: 10px;
    margin-right: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/tianbaoSubmit.vue